import * as React from "react";
import {cx} from "emotion";

import "./money-span.scss";

import {cs}          from "@Common/react/chain-services";
import {Badge}       from "@Common/ui-components/heavy/common/design2/badge/badge";
import {SubtleBadge} from "@Common/ui-components/heavy/common/design2/subtle-badge/subtle-badge";
import {formatMoney} from "@Common/ui-components/language/format-money";

export const MoneySpanOld = ({value, alwaysShowDollarSymbol=false, useFreeLabel=true}) => cs(
    () => (!value && !alwaysShowDollarSymbol) ? (
        Badge({
            color: "green",
            text: "Free",
            xdQaName: "File Download Amount"
        })
    ) : (
        <div className="money-span money-span-233 money" xd-qa-type="text" xd-qa-name="File Download Amount">
            {formatMoney(value, {useFreeLabel, alwaysShowDollarSymbol})}
        </div>
    )
);

export const MoneySpanHideFree = ({value}) => cs(
    () => !value ? (
        null
    ) : (
        <div className="money-span money-span-233 money">
            {formatMoney(value)}
        </div>
    )
);

export const MoneySpan = ({value, freeBadge=true, xdQaName=undefined}) => (
    <div className={cx("money-span money-span-233", !value ? "free" : "money")}>
        {!value && freeBadge ? (
            Badge({
                color: "green",
                text: "Free",
            })
        ) : (
            SubtleBadge({
                message: formatMoney(value),
                xdQaName,
            })
        )}
    </div>
);

export const MoneySpanDiscount = ({value, discountValue, xdQaName=undefined}) => (
    <div className={cx("money-span money-span-233", !value ? "free" : "money")}>
        {!value ? (
            Badge({
                color: "green",
                text: "Free",
            })
        ) : (
            <div className="price-comparison">
                <div className="discounted-price" xd-qa-type="text" xd-qa-name="Discounted Price">
                    {formatMoney(discountValue)}
                </div>
                <div className="price" xd-qa-type="text" xd-qa-name="Price">
                    <span className="strike-through">{formatMoney(value)}</span>
                </div>
            </div>
        )}
    </div>
)